var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Heading } from '../../../shared';
import React, { useState } from 'react';
import { services } from '../../../../shared';
import Markdown from 'react-markdown';
import RehypeRaw from 'rehype-raw';
import RehypeSanitize from 'rehype-sanitize';
import { pageContentValues } from '../../../../shared/types/constants';
import './announcement.scss';
export var AnnouncementModal = function (_a) {
    var isOpen = _a.isOpen, setToggle = _a.setToggle;
    var mouseClick = function (event) {
        var _a;
        if (!((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.closest('.c-announcement'))) {
            document.removeEventListener('click', mouseClick);
            setToggle(false);
        }
    };
    document.addEventListener('click', mouseClick);
    var _b = useState(), fetchedAnnouncement = _b[0], setFetchedAnnouncement = _b[1];
    var _c = useState(false), isReadMore = _c[0], setReadMore = _c[1];
    var fetchAnnouncement = function () { return __awaiter(void 0, void 0, void 0, function () {
        var announcementData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getModuleTextNullable(pageContentValues.brokerAnnouncement.content)];
                case 1:
                    announcementData = _a.sent();
                    if (announcementData && announcementData.isSuccess)
                        setFetchedAnnouncement(announcementData.data);
                    return [2 /*return*/];
            }
        });
    }); };
    var hasTextExceededMax = function (announcement) {
        return (announcement === null || announcement === void 0 ? void 0 : announcement.description.length) > 40;
    };
    if (!fetchedAnnouncement) {
        fetchAnnouncement();
    }
    var applyReadMore = function () {
        setReadMore(!isReadMore);
    };
    return (React.createElement("section", { className: "c-announcement-section", hidden: !isOpen },
        React.createElement("div", { className: "speech-bubble" },
            React.createElement("div", { className: "c-announcement-container__header" },
                React.createElement(Heading, { level: "h3", title: "Announcements" })),
            React.createElement("div", { className: "c-announcement-container__body" },
                React.createElement("div", null,
                    isReadMore ? (React.createElement(Markdown, { children: fetchedAnnouncement === null || fetchedAnnouncement === void 0 ? void 0 : fetchedAnnouncement.description, rehypePlugins: [RehypeRaw, RehypeSanitize] })) : (React.createElement(Markdown, { children: fetchedAnnouncement === null || fetchedAnnouncement === void 0 ? void 0 : fetchedAnnouncement.description.substr(0, 40), rehypePlugins: [RehypeRaw, RehypeSanitize] })),
                    hasTextExceededMax(fetchedAnnouncement) && !isReadMore ? '...' : ''),
                React.createElement("div", null,
                    React.createElement(Button, { type: "button", variant: "bare", childClasses: hasTextExceededMax(fetchedAnnouncement) ? 'btn-see-more' : 'btn-see-more hidden-label', onClick: applyReadMore }, isReadMore ? 'See less' : 'See more')),
                React.createElement("div", { className: "c-announcement-date" },
                    React.createElement("small", null, fetchedAnnouncement === null || fetchedAnnouncement === void 0 ? void 0 : fetchedAnnouncement.lastUpdateDate))))));
};
